// Predefined employee names (editable later)
export const EMPLOYEE_NAMES = ['アジ', 'バト', 'ケヴィン', 'デオ'];

// Standard breaks during work day (minutes)
const BREAKS = [
  { start: '10:00', end: '10:05' }, // 5 min
  { start: '12:00', end: '12:40' }, // 40 min
  { start: '15:00', end: '15:10' }, // 10 min
];

const timeToMinutes = (timeStr) => {
  if (!timeStr) return 0;
  const [h, m] = timeStr.split(':').map(Number);
  return h * 60 + m;
};

const calculateBreakOverlap = (startMin, endMin) => {
  let totalBreakMin = 0;
  for (const brk of BREAKS) {
    const brkStart = timeToMinutes(brk.start);
    const brkEnd = timeToMinutes(brk.end);
    const overlap = Math.max(0, Math.min(endMin, brkEnd) - Math.max(startMin, brkStart));
    totalBreakMin += overlap;
  }
  return totalBreakMin;
};

/**
 * Calculate Holiday Work hours
 * Total = (end - start) - breaks that fall within the range
 */
export const calculateHolidayHours = (startTime, endTime) => {
  if (!startTime || !endTime) return 0;
  const startMin = timeToMinutes(startTime);
  const endMin = timeToMinutes(endTime);
  if (endMin <= startMin) return 0;
  
  const breakMin = calculateBreakOverlap(startMin, endMin);
  const workMin = endMin - startMin - breakMin;
  return Math.round((workMin / 60) * 100) / 100; // 2 decimal places
};

/**
 * Calculate Normal Overtime hours
 * Always starts at 17:30, max counted is 2 hours (17:30-19:30)
 * Even if employee works past 19:30, only 2 hours counted
 */
export const calculateOvertimeHours = (endTime) => {
  if (!endTime) return 0;
  const endMin = timeToMinutes(endTime);
  const startMin = timeToMinutes('17:30');
  const maxEndMin = timeToMinutes('19:30');
  
  if (endMin <= startMin) return 0;
  
  // Cap at 19:30 (max 2 hours)
  const effectiveEnd = Math.min(endMin, maxEndMin);
  const workMin = effectiveEnd - startMin;
  return Math.round((workMin / 60) * 100) / 100;
};
